export default __webpack_public_path__ + "static/media/OpenSans-MediumItalic.c184e31a.ttf";